import { NotificationEventEnum } from '.'
import { IFIStatus } from '../statuses/ifi'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const ifi = 'Identified Field Issue'

const IssueSuggested = new NotificationEventItem({
  id: '0A7DF347-F828-458D-AFFD-106DD5A38FFB',
  name: 'Issue Suggested',
  description: `An ${ifi} is imported from the CIMS Field App`,
})

const IssueSummarized = new NotificationEventItem({
  id: '73CC47B3-987C-4A91-8052-4224C547D09A',
  name: 'Issue Summarized',
  description: `A summary list of recently created ${ifi}s, sent out on a time interval`,
})

const Closed = new NotificationEventItem({
  id: 'DFF7276C-7FFE-4512-9A0B-B92E10815AF2',
  name: 'Closed',
  description: `A User reviews and closes an ${ifi}`,
})
const Edited = EditedNotificationEventItem({
  id: '7F83D348-54CC-4CE1-9145-CE163221CD1C',
  editable: 'Identified Field Issue',
})
const Reverted = RevertedNotificationEventItem({
  id: '29BA1E78-E2EE-46F7-A4B9-EC7F42AA778F',
  revertable: 'Identified Field Issue',
  from: IFIStatus.Closed,
  to: IFIStatus.PendingReview,
})
const Commented = CommentedNotificationEventItem({
  id: '6E0D4794-613C-42CE-AF8E-2D7FE291E20C',
  commentable: 'Identified Field Issue',
})

export type IFINotificationEventItem =
  | typeof IssueSuggested
  | typeof Closed
  | typeof Edited
  | typeof Reverted
  | typeof Commented
  | typeof IssueSummarized

class IFINotificationEventEnum extends NotificationEventEnum<
  'IFINotification',
  IFINotificationEventItem,
  IFINotificationEventItem['name'],
  IFINotificationEventItem['id']
> {
  typename = 'IFINotification' as const
  get values() {
    return [
      this.IssueSuggested,
      this.Closed,
      this.Edited,
      this.Reverted,
      this.Commented,
      this.IssueSummarized,
    ]
  }
  readonly IssueSuggested = IssueSuggested
  readonly Closed = Closed
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Commented = Commented
  readonly IssueSummarized = IssueSummarized
}

export const IFINotificationEvent = new IFINotificationEventEnum()
